import apiClient from "./middleware";
import type {
  BannerSwapAdminActionResponse,
  BannerSwapAdminChannelTarget,
  BannerSwapAdminIssuesResponse,
} from "../utils/bannerSwapAdminOps.types";

export type {
  BannerSwapAdminActionResponse,
  BannerSwapAdminChannelTarget,
  BannerSwapAdminIssue,
  BannerSwapAdminIssueKind,
  BannerSwapAdminIssuesResponse,
} from "../utils/bannerSwapAdminOps.types";

/** Admin-only Banner Swap ops (server enforces role === admin). */
export const bannerSwapAdminOpsApi = {
  getIssues: async (): Promise<BannerSwapAdminIssuesResponse> => {
    const response = await apiClient.get<BannerSwapAdminIssuesResponse>(
      "/BannerSwap/Admin/Issues"
    );
    return response.data;
  },

  reconcile: async (body: {
    targets: BannerSwapAdminChannelTarget[];
    dryRun?: boolean;
    reconcileOnly?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/Reconcile",
      body
    );
    return response.data;
  },

  forceReenqueueStarts: async (body: {
    targets: BannerSwapAdminChannelTarget[];
    dryRun?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/ForceReenqueueStarts",
      body
    );
    return response.data;
  },

  forceReenqueueEnds: async (body: {
    targets: BannerSwapAdminChannelTarget[];
    dryRun?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/ForceReenqueueEnds",
      body
    );
    return response.data;
  },

  retryStuckStarts: async (body?: {
    swapUID?: string;
    dryRun?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/RetryStuckStarts",
      body ?? {}
    );
    return response.data;
  },

  retryStuckEnds: async (body?: {
    swapUID?: string;
    dryRun?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/RetryStuckEnds",
      body ?? {}
    );
    return response.data;
  },

  pushDefaults: async (body: {
    channelIds: string[];
    dryRun?: boolean;
  }): Promise<BannerSwapAdminActionResponse> => {
    const response = await apiClient.post<BannerSwapAdminActionResponse>(
      "/BannerSwap/Admin/PushDefaults",
      body
    );
    return response.data;
  },
};
